import React from "react";
import styled from "styled-components";
import { createRoot } from "react-dom/client";
import { Dialog, Box, Divider } from "@mui/material";
import { Text } from "src/components";

const MODAL_CONTAINER_ID = "modal-container";

const StyledText = styled(Text)`
  font-family: Manrope, Helvetica, sans-serif;
  text-align: left;
  padding: ${p => p.padding || 0};
  margin: ${p => p.margin || 0};
`;

const createModal = (modalHeader, modalBody, easyDismiss, modalLoading) => {
    const modalContainer = document.createElement("div");

    ClientLicenseModal._modalContainer = modalContainer;
    ClientLicenseModal.instance.appendChild(modalContainer);

    const dismissEvent = () => {
        if (ClientLicenseModal._modalContainer) {
            ClientLicenseModal._modalRoot?.unmount();
            ClientLicenseModal._modalRoot = null;
            if (ClientLicenseModal._modalContainer.parentNode) {
                ClientLicenseModal._modalContainer.parentNode.removeChild(ClientLicenseModal._modalContainer);
            }
            ClientLicenseModal._modalContainer = null;
        }
        if (ClientLicenseModal.instance && ClientLicenseModal.instance.parentNode) {
            ClientLicenseModal.instance.parentNode.removeChild(ClientLicenseModal.instance);
            ClientLicenseModal.instance = null;
        }
    };

    const modalContent = (
        <Dialog
            open={true}
            onClose={easyDismiss ? dismissEvent : null}
            maxWidth="md"
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    width: "846px",
                    height: "481px",
                    minHeight: "481px",
                    borderRadius: 15,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                },
            }}
        >
            <Box
                sx={{
                    padding: "2rem 3.5rem 0.5rem 3.5rem",
                    flexShrink: 0,
                }}
            >
                <StyledText color="#11141A" size="2.5rem" weight="600" margin="0 0 0.25rem 0">
                    {modalHeader}
                </StyledText>
                <StyledText color="#000000" size="14px" margin="0">
                    Please choose your preferred method of sending the renewal link to the designated user.
                </StyledText>
            </Box>
            <Divider />
            <Box
                sx={{
                    padding: "1rem 3.5rem",
                    overflowY: "auto",
                    flexGrow: 1,
                }}
            >
                {modalBody}
            </Box>
            <Divider />
        </Dialog>
    );


    ClientLicenseModal._modalRoot = createRoot(modalContainer);
    ClientLicenseModal._modalRoot.render(modalContent);
};

class ClientLicenseModal {  
    static instance;
    static _modalRoot;

    static init() {
        let exists = document.getElementById(MODAL_CONTAINER_ID);

        if (exists) {
            ClientLicenseModal.instance = exists;
            ClientLicenseModal.instance.id = MODAL_CONTAINER_ID;
            document.body.removeChild(ClientLicenseModal.instance);
        }

        ClientLicenseModal.instance = document.createElement("div");
        ClientLicenseModal.instance.id = MODAL_CONTAINER_ID;
        document.body.appendChild(ClientLicenseModal.instance);
    }

    /** There can only every be one modal active at a time. */
    static open(modalHeader = "", modalBody = "", easyDismiss = true) {
        if (!ClientLicenseModal.instance || !document.getElementById(MODAL_CONTAINER_ID)) {
            ClientLicenseModal.init();
        }
        
        createModal(modalHeader, modalBody, easyDismiss);
    }

    /** Allows for programmatic closing of a modal. */
    static close() {
        if (!ClientLicenseModal._modalContainer) {
            console.warn("There is no modal to close.");
            return;
        }

        ClientLicenseModal._modalRoot?.unmount();
        ClientLicenseModal._modalRoot = null;

        if (ClientLicenseModal._modalContainer.parentNode) {
            ClientLicenseModal._modalContainer.parentNode.removeChild(ClientLicenseModal._modalContainer);
            ClientLicenseModal._modalContainer = null;
        }

        if (ClientLicenseModal.instance && ClientLicenseModal.instance.parentNode) {
            ClientLicenseModal.instance.parentNode.removeChild(ClientLicenseModal.instance);
            ClientLicenseModal.instance = null;
        }
    }
}

export default ClientLicenseModal;
